import axios from "axios";
import { ENDPOINTS } from "./endpoints";

export const getStackHolderQueries = async (params) => {
  try {
    const response = await axios.get(`${ENDPOINTS.STACK_HOLDER_QUERY.GET}`, {
      params,
    });
    return response.data; // Assuming the API returns the list of users directly
  } catch (error) {
    // Handle errors or re-throw them
    throw error;
  }
};

export const getStackHolderQueryById = async (id) => {
  try {
    const response = await axios.get(
      `${ENDPOINTS.STACK_HOLDER_QUERY.GET_QUERY}/${id}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const replyStackHolderQuery = async (data) => {
  const axiosConfig = {
    method: "post",
    url: ENDPOINTS.STACK_HOLDER_QUERY.QUERY_REPLY,
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
  };

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  }
};

export const stackHolderQueryStatus = async (id) => {
  try {
    const response = await axios.get(
      `${ENDPOINTS.STACK_HOLDER_QUERY.STACK_HOLDER_QUERY_STATUS}?stakeholder_experiences_id=${id}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStackHolderDashboardData = async (organization_id = null) => {
  try {
    const response = await axios.get(
      `${ENDPOINTS.STACK_HOLDER_QUERY.STACK_HOLDER_QUERY_DASHBOARD}?organization_id=${organization_id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const saveWebFCMToken = async (token) => {
  try {
    const response = await axios.post(
      `${ENDPOINTS.STACK_HOLDER_QUERY.SAVE_WEB_FCM_TOKEN}?token=${token}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getReguestTypeList = async () => {
  try {
    const response = await axios.get(
      ENDPOINTS.STACK_HOLDER_QUERY.GET_REQUEST_TYPE_LIST
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getFlagList = async () => {
  try {
    const response = await axios.get(
      ENDPOINTS.STACK_HOLDER_QUERY.GET_FLAG_LIST
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateStackHolderQueryFlag = async (data) => {
  try {
    const response = await axios.post(
      `${ENDPOINTS.STACK_HOLDER_QUERY.UPDATE_FLAG}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateStackHolderQueryStatus = async (data) => {
  try {
    const response = await axios.post(
      `${ENDPOINTS.STACK_HOLDER_QUERY.UPDATE_STATUS}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateStackHolderQuerySubType = async (data) => {
  try {
    const response = await axios.post(
      `${ENDPOINTS.STACK_HOLDER_QUERY.UPDATE_REQUEST_SUB_TYPE}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const removeReplyAttachment = async (data) => {
  try {
    const response = await axios.post(
      `${ENDPOINTS.STACK_HOLDER_QUERY.REMOVE_REPLY_ATTACHMENT}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const addSuggestion = async (data) => {
  try {
    const response = await axios.post(
      `${ENDPOINTS.STACK_HOLDER_QUERY.ADD_SUGGESTION}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getQueryViewerUsers = async (organization_id) => {
  try {
    const response = await axios.get(
      `${ENDPOINTS.STACK_HOLDER_QUERY.GET_QUERY_VIEWER_USERS}?organization_id=${organization_id}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
